import { render, staticRenderFns } from "./Farmlist.vue?vue&type=template&id=109c6134&"
import script from "./Farmlist.vue?vue&type=script&lang=js&"
export * from "./Farmlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports